"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generalBookingError(_state, _getters, _rootState, rootGetters) {
    return rootGetters['booking/general/bookingError'];
}
function generalCountries(_state, _getters, _rootState, rootGetters) {
    return rootGetters['booking/general/countries'];
}
function generalCruise(_state, _getters, _rootState, rootGetters) {
    return rootGetters['booking/general/cruise'];
}
// export everything compliant to the vuex specification for getters
exports.default = {
    generalBookingError: generalBookingError, generalCountries: generalCountries, generalCruise: generalCruise
};
//# sourceMappingURL=external_general.js.map